import React from "react";
import { Box, Typography, Container } from "@mui/material";

const Greeting = ({ profileData }) => {
  const date = new Date();
  const hours = date.getHours();
  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  let month = months[date.getMonth()];
  let today = `${date.getUTCDate()} ${month} ${date.getFullYear()}`;

  let greeting = 
    hours < 12 ? "Good morning" :
    hours < 18 ? "Good afternoon" :
    hours < 21 ? "Good evening" : "Good night";

  const firstName = profileData?.user?.fname || "";

  return (
    <Box py={3} px={4} sx={{ maxWidth: "1300px", mx: "auto" }}>
      <Container maxWidth="lg" sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Typography variant="h3" sx={{ fontSize: { xs: "1.5rem", sm: "2rem" } }}>
          👋
          </Typography>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Typography variant="h4" sx={{ fontWeight: "bold", fontSize: { xs: "1.2rem", sm: "1.8rem" } }}>
              {greeting}
            </Typography>
            <Typography variant="h4" sx={{ fontWeight: "bold", fontSize: { xs: "1.2rem", sm: "1.8rem" } }}>
              {firstName}
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Greeting;